import { render, staticRenderFns } from "./ProjectsNew.vue?vue&type=template&id=48f34f5c&"
import script from "./ProjectsNew.vue?vue&type=script&lang=js&"
export * from "./ProjectsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports